import { useContext } from 'react';

import { useAppSelector, useAppDispatch } from 'hooks';

import { Text, SimpleGrid } from '@chakra-ui/react';

import Card from 'components/card/Card';

import DateInput from 'components/fields/auto/DateInput';
import TimeInput from 'components/fields/auto/TimeInput';

import getDateFromString from 'helpers/getDateFromString';
import getFileType092 from 'helpers/getFileType092';

import { changePolicyPeriod } from 'reducers/autoPersonalFormReducer';

import getDateString from 'helpers/getDateString';

import { SECTIONS } from 'views/auto_form/constants';

import { ApplicationFormContext } from 'contexts/ApplicationFormContext';

const PolicyPeriod = () => {
  const dispatch = useAppDispatch();
  const { validations } = useContext(ApplicationFormContext);

  const data = useAppSelector(
    (state) => state.autoPersonalForm.data.policy_period,
  );

  const fileType = getFileType092(validations);

  const onDateChange = (date: Date, name: string) => {
    dispatch(changePolicyPeriod({ name, value: getDateString(date) }));
  };

  const onTimeChange = (time: string) => {
    dispatch(
      changePolicyPeriod({
        name: 'effective_date_time',
        value: time,
      }),
    );
  };

  return (
    <Card mb="20px" id="sectionPolicyPeriod">
      <Text fontWeight="bold" fontSize="2xl" mb="20px">
        Policy Period
      </Text>

      <SimpleGrid columns={3} spacing="20px" mb="20px">
        <DateInput
          section={SECTIONS.POLICY_PERIOD}
          label="Effective Date"
          date={getDateFromString(data.effective_date)}
          onChange={(date: Date) => onDateChange(date, 'effective_date')}
          message={{
            validationId: '092',
            file: fileType,
            hideRemarks: true,
          }}
          required
          disabled
        />
        <TimeInput
          section={SECTIONS.POLICY_PERIOD}
          label="Effective Time"
          value={data.effective_date_time || ''}
          onChange={onTimeChange}
          required
        />
        <DateInput
          section={SECTIONS.POLICY_PERIOD}
          label="Expiry Date"
          date={getDateFromString(data.expiry_date)}
          onChange={(date: Date) => onDateChange(date, 'expiry_date')}
          required
          disabled
        />
      </SimpleGrid>
    </Card>
  );
};

export default PolicyPeriod;
